<template>
    <div>
        <div :class="$route.name=='ProductDetails'?'breadcrumb2':'breadcrumb'">
            <div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item><span style="color: #D70606;">{{tit}}</span></el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="productDetails">
            <div>
                <div>
                    <el-image v-if="details.facImgUrl" style="width: 100%; height: 100%" :src="details.facImgUrl"
                        fit="scale-down" :preview-src-list="[details.facImgUrl]">
                    </el-image>
                    <img v-else src="../../assets/prodect.jpg" fit="scale-down">
                </div>
                <div>
                    <div>
                        <div>{{details.platformName}}</div>
                        <div>
                            <div class="blue"><i class="iconfont icon-suoshufenlei"></i> 所属分类 {{details.tagName}}</div>
                            <div class="blue"><i class="iconfont icon-suoshudengji"></i> 所属等级 {{details.facCateName}}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div>编码</div>
                            <div>{{details.facCateCode}}</div>
                        </div>
                        <div>
                            <div>外观样式</div>
                            <div>{{details.facType}}</div>
                        </div>
                        <div>
                            <div>包装规格</div>
                            <div>{{details.facPacking}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <div>技术要求</div>
                    <div>{{details.facRequire}}</div>
                </div>
                <div>
                    <div>产品介绍</div>
                    <div>{{details.facIntroduce}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProductDetails",
        data() {
            return {
                tit: '',
                details: {
                    businessNo: null,
                    facBusinessNo: null,
                    facCateCode: null,
                    facCateName: null,
                    facImgUrl: null,
                    facIntroduce: null,
                    facPacking: null,
                    facRequire: null,
                    facType: null,
                    facUnit: null,
                    id: null,
                    isAble: null,
                    platformId: null,
                    platformName: null,
                    tagName: null
                }
            }
        },
        created() {
            this.getDetails();
        },
        methods: {
            getDetails() {
                this.request.get(this.$store.state.httpUrl + "mobileInterf/queryProductTwoById-ry", {
                    params: {
                        code: this.$route.query.facCateCode
                    }
                }).then(res => {
                    if (res.status == '200') {
                        this.details = res.data;
                        // this.$route.meta.name = res.data.platformName + '-' + res.data.facCateName;
                        this.tit = res.data.platformName + '-' + res.data.facCateName;
                    }
                });
            }
        }
    };
</script>

<style scoped>
    .breadcrumb {
        background-color: #FFFFFF;
    }

    .breadcrumb2>div,
    .breadcrumb>div {
        width: 1200px;
        height: 48px;
        margin: 0 auto;
        padding: 14px 0;
        box-sizing: border-box;
    }
    
    .productDetails {
        background: #E5ECF9;
        text-align: left;
        width: 1200px;
        box-sizing: border-box;
        margin: 0 auto;
        padding-bottom: 50px;
    }

    .productDetails>div:nth-child(1) {
        display: flex;
        justify-content: space-between;
    }

    .productDetails>div:nth-child(1)>div:nth-child(1) {
        width: 470px;
        height: 360px;
        background: #FFFFFF;
        border-radius: 10px;
        box-sizing: border-box;
        text-align: center;
    }

    .productDetails>div:nth-child(1)>div:nth-child(1)>img {
        height: 100%;
        max-width: 100%;
    }

    .productDetails>div:nth-child(1)>div:nth-child(2)>div {
        padding: 24px;
        width: 692px;
        height: 170px;
        background: #FFFFFF;
        border-radius: 10px;
        box-sizing: border-box;
    }

    .productDetails>div:nth-child(1)>div:nth-child(2)>div:nth-child(1)>div:nth-child(1) {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
    }

    .productDetails>div:nth-child(1)>div:nth-child(2)>div:nth-child(1)>div:nth-child(2) {
        width: 644px;
        height: 78px;
        background: #F3FAFF;
        border-radius: 10px;
        padding: 0 24px;
        box-sizing: border-box;
        margin-top: 24px;
    }

    .productDetails>div:nth-child(1)>div:nth-child(2)>div:nth-child(1)>div:nth-child(2)>div {
        font-size: 16px;
        font-weight: bold;
        padding-top: 15px;
    }

    .productDetails>div:nth-child(1)>div:nth-child(2)>div:nth-child(2)>div {
        display: flex;
        justify-content: space-between;
    }

    .productDetails>div:nth-child(1)>div:nth-child(2)>div:nth-child(2) {
        margin-top: 20px;
        font-size: 14px;
    }

    .productDetails>div:nth-child(1)>div:nth-child(2)>div:nth-child(2) {
        padding: 19px 24px;
    }

    .productDetails>div:nth-child(1)>div:nth-child(2)>div:nth-child(2)>div {
        line-height: 24px;
    }

    .productDetails>div:nth-child(1)>div:nth-child(2)>div:nth-child(2)>div>div:nth-child(1) {
        color: #999999;
        width: 56px;
        text-align: right;
    }

    .productDetails>div:nth-child(1)>div:nth-child(2)>div:nth-child(2)>div>div:nth-child(2) {
        width: calc(100% - 90px);
        color: #333333;
        box-sizing: border-box;
    }

    .productDetails>div:nth-child(2) {
        width: 1200px;
        background: #FFFFFF;
        border-radius: 10px;
        padding: 24px;
        padding-bottom: 0;
        margin-top: 26px;
        box-sizing: border-box;
    }

    .productDetails>div:nth-child(2)>div>div:nth-child(1) {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        border-bottom: solid 2px #5F93FF;
        padding-bottom: 10px;
    }

    .productDetails>div:nth-child(2)>div>div:nth-child(2) {
        padding-top: 10px;
        font-size: 14px;
        color: #333333;
        line-height: 28px;
        padding-bottom: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/view/other/productDetails.vue